import { jsx as _jsx } from "react/jsx-runtime";
import { freddyTheme, ListItem, Typography } from '@coolblue-development/freddy';
export const SectionTitle = ({ children }) => (_jsx(ListItem, { children: _jsx(Typography, { m: 0, variant: "h4", color: freddyTheme.color.font.base, display: "block", fontWeight: freddyTheme.typography.fontWeight.openSans.bold, py: 200, px: 400, fontSize: freddyTheme.typography.fontSize.lg, sx: {
            textDecoration: 'none',
        }, children: children }) }));
export const sectionStyles = {
    paddingTop: freddyTheme.spacing[200],
    borderTop: `${freddyTheme.borderWidth[25]} solid ${freddyTheme.color.border.interactiveBase}`,
    [freddyTheme.breakpoint.maxWidth('md')]: {
        '&:first-of-type': {
            marginTop: freddyTheme.spacing[0],
        },
    },
    '&.typehead-default-suggestion:not(:only-child)': {
        display: 'none',
    },
};
export const resultContainerStyles = {
    position: 'absolute',
    left: 0,
    top: '100%',
    width: '100%',
    height: 'calc(100dvh - 4.4rem)',
    maxHeight: 'calc(100dvh - var(--cb-header-height-inner))',
    overflowX: 'hidden',
    overflowY: 'auto',
    background: freddyTheme.color.background.base,
    borderRadius: `0 0 ${freddyTheme.borderRadius[100]} ${freddyTheme.borderRadius[100]}`,
    padding: `${freddyTheme.spacing[0]} ${freddyTheme.spacing[0]} ${freddyTheme.spacing[200]}`,
    transformOrigin: 'top',
    '@keyframes scale-drop-down-typeahead': {
        '0%': {
            transform: 'scale(1, 0.7)',
        },
    },
    animation: 'scale-drop-down-typeahead 0.25s cubic-bezier(0.1, 1.45, 0.35, 1)',
    [freddyTheme.breakpoint.maxWidth('md')]: {
        overflow: 'scroll',
        overscrollBehavior: 'contain',
    },
    [freddyTheme.breakpoint.minWidth('md')]: {
        width: 'calc(100% - 2.4rem)',
        top: 'calc(100% - 0.7rem)',
        left: '1.2rem',
        padding: `${freddyTheme.spacing[0]} ${freddyTheme.spacing[0]} ${freddyTheme.spacing[200]} ${freddyTheme.spacing[0]}`,
        height: 'auto',
    },
    '&:empty': {
        display: 'none',
    },
};
export const getTypeaheadStyles = (isOpen) => ({
    position: 'relative',
    minHeight: '4rem',
    maxWidth: '56rem',
    width: '100%',
    transition: 'top 0.25s ease-in-out, background-color 0.25s ease-in-out',
    transitionDelay: 'top 0.25s',
    zIndex: '101',
    [freddyTheme.breakpoint.maxWidth('md')]: {
        position: isOpen ? 'fixed' : 'absolute',
        left: 0,
        top: isOpen ? 0 : 'var(--cb-header-height-inner)',
        backgroundColor: freddyTheme.color.background.secondary,
        marginLeft: isOpen ? 0 : 'calc(-1 * var(--cb-spec-container-horizontal-padding))',
        width: isOpen ? '100%' : 'calc(100% + calc(2 * var(--cb-spec-container-horizontal-padding)))',
        maxWidth: 'initial',
    },
});
export const suggestionListItemStyles = {
    textDecoration: 'none',
    color: freddyTheme.color.font.base,
    fontWeight: freddyTheme.typography.fontWeight.openSans.bold,
    padding: `${freddyTheme.spacing[200]} ${freddyTheme.spacing[400]}`,
    margin: 0,
    cursor: 'pointer',
    textAlign: 'left',
    whiteSpace: 'normal',
    '&:hover': {
        backgroundColor: freddyTheme.color.background.interactiveHovered,
    },
    '& > a:only-child': {
        textDecoration: 'none',
        display: 'block',
    },
};
//# sourceMappingURL=Typeahead.styles.js.map